// Interfaces
import { ILabeledInput } from "./interfaces";

// Layouts
import InputFormExtension from "../InputFormExtension";

// MUI
import { Divider, Stack, Typography } from "@mui/material";

export default function LabeledInput(props: Readonly<ILabeledInput>) {
	const { label, labelClassName, fontSize = "16px", input, divider, dividerStyle, componentProps, disabled, readOnly } = props;
	return (
		<Stack direction="row" position={"relative"} alignContent={"center"} alignItems={"center"} sx={componentProps?.sx}>
			<Typography className={labelClassName || "regular-montserrat-label"} sx={{ fontSize }}>
				{label}
			</Typography>
			<InputFormExtension {...input} disabled={input?.disabled || disabled || input?.readOnly || readOnly} />
			{divider && (
				<Divider
					className="!border-disabled"
					textAlign="center"
					orientation="vertical"
					variant="middle"
					style={{
						maxHeight: "20px",
						marginTop: "8px",
						position: "absolute",
						right: "-20px",
						...dividerStyle,
					}}
				/>
			)}
		</Stack>
	);
}
